<div
    class="flex flex-col px-10 py-4 border-2 rounded-md"
    [ngClass]="error ? 'border-red-500' : 'border-gray-900/10'"
>
    <div class="text-lg font-semibold my-1">
        {{ title }}
    </div>

    <div class="w-1/3">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full">
            <mat-select [placeholder]="placeholder" [(ngModel)]="value" (selectionChange)="onChange($event)">
                <mat-option [value]="null">-</mat-option>
                @for (opt of options; track $index) {
                    <mat-option [value]="optionValue ? opt[optionValue] : opt">
                        {{ optionLabel ? opt[optionLabel] : opt }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    @if (error) {
        <div class="py-2 px-1 text-red-500 font-semibold">
            *Molimo odaberite opciju
        </div>
    }
</div>
